export default __webpack_public_path__ + "static/logoSampoerna-9aa61a1704cfb0a6ea1099ba94cb5be3.svg";